/* *************************************************************** *
 * THIS IS AN AUTO GENERATED FILE. PLEASE DO NOT EDIT IT DIRECTLY.
 *
 * If you want to change this Icon component , it is generated
 * from the `iconTamplate.js` file the parent directory.
 * *************************************************************** */
/* eslint-disable */
import React from 'react';
import { useFela, } from 'react-fela';
import iconStyle from '../iconStyle';
import { iconPropTypes, iconDefaultProps, } from '../iconPropTypes';

export default function IconCamera({ size, fill, color, attrs, miscStyles, ...props }) {
  const className = useFela({ size, fill, color, miscStyles, }).css(iconStyle);

  return (
    <svg width="1em" height="1em" viewBox="0 0 256 256" className={className} {...props} {...attrs} data-test="IconCamera">  <path fill="currentColor" d="M170.4 76L161 51H90.9l-9.4 25H34v128h189V76h-52.6zm-41.9 106.2c-23.6 0-42.7-19.1-42.7-42.7s19.1-42.7 42.7-42.7 42.7 19.1 42.7 42.7-19.1 42.7-42.7 42.7zm27.3-42.8c0 15-12.2 27.2-27.2 27.2s-27.2-12.2-27.2-27.2 12.2-27.2 27.2-27.2c15-.1 27.2 12.1 27.2 27.2z" /></svg>
  );
}

IconCamera.propTypes = iconPropTypes;
IconCamera.defaultProps = iconDefaultProps;
